import React from "react";
import { Link } from "react-router-dom";
import "./Web1920150.css";

function Web1920150(props) {
  const { overlapGroup1, backToImage } = props;

  return (
    <div className="container-center-horizontal">
      <div className="web-1920-150 screen">
        <div className="overlap-group1-13" style={{ backgroundImage: `url(${overlapGroup1})` }}>
          <div className="rectangle-2-23 border-1px-dove-gray"></div>
          <Link to="/web-1920-130">
            <div className="group-142-6">
              <div className="overlap-group-26">
                <div className="rectangle-33-11 border-3px-picton-blue"></div>
                <div className="back-to-image-4 lato-medium-white-13px">{backToImage}</div>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Web1920150;
